export default{
  ReadProps(action="Read",self,onsuccess,onfailed){
    return {
        data : {
          query:self.state.query,
          AuthorizationToken : self.props.UserReducer.token,
        },
        action : action,
        Reducer: self.props.Reducer,
        RunRedux : self.props.RunRedux,
        onfailed : self.__OnReadFailed__,
        onsuccess : self.__OnReadSuccess__,

    }

  },
  RegisterProps(onsuccess,onfailed,permission_needed,self){
    return {
        data : {
          Username:self.state.Register.Username,
          Email : self.state.Register.Email,
          Phone : self.state.Register.Phone,
          Password:self.state.Register.Password,
          FirstName : self.state.Register.FirstName,
          LastName: self.state.Register.LastName,
          RoleAlias : self.state.Register.RoleAlias,
          Tag: self.state.Register.Tag,
          Address : self.state.Register.Address,
          Address2: self.state.Register.Address2,
          CityAbbreviations : self.state.Register.CityAbbreviations,
          Postal : self.state.Register.Postal,
          AuthorizationToken : self.props.UserReducer.token,
        },
        UserReducer: self.props.UserReducer,
        RunRedux : self.props.RunRedux,
        onfailed : onfailed,
        onsuccess : onsuccess,
        permission_needed:permission_needed,
        self:self,
    }
  },
  UpdateProps(onsuccess,onfailed,permission_needed,self){
    return {
        data : {
          Alias              : self.state.Update.Alias,
          Username           : self.state.Update.Username,
          Email              : self.state.Update.Email,
          Phone              : self.state.Update.Phone,
          Password           : self.state.Update.Password,
          FirstName          : self.state.Update.FirstName,
          LastName           : self.state.Update.LastName,
          RoleAlias          : self.state.Update.RoleAlias,
          Tag                : self.state.Update.Tag,
          Address            : self.state.Update.Address,
          Address2           : self.state.Update.Address2,
          CityAbbreviations  : self.state.Update.CityAbbreviations,
          Postal             : self.state.Update.Postal,
          Active             : self.state.Update.Active,
          AuthorizationToken : self.props.UserReducer.token,
        },
        UserReducer: self.props.UserReducer,
        RunRedux : self.props.RunRedux,
        onfailed : onfailed,
        onsuccess : onsuccess,
        permission_needed:permission_needed,
        self:self,
    }
  },
  DeleteProps(onsuccess,onfailed,permission_needed,self){
    return {
        data : {
          Alias : self.state.Delete.Alias,
          RoleAlias : self.state.Delete.RoleAlias,
          Tag: self.state.Delete.Tag,
          Address : self.state.Delete.Address,
          AuthorizationToken : self.props.UserReducer.token,
        },
        UserReducer: self.props.UserReducer,
        RunRedux : self.props.RunRedux,
        onfailed : onfailed,
        onsuccess : onsuccess,
        permission_needed:permission_needed,
        self:self,
    }
  },
  UpdateSelfProps(onsuccess,onfailed,permission_needed,self){
    return {
        data : {
          Alias : self.state.Props.Alias,
          Username:self.state.Props.Username,
          Email : self.state.Props.Email,
          Phone : self.state.Props.Phone,
          Password:self.state.Props.Password,
          FirstName : self.state.Props.FirstName,
          LastName: self.state.Props.LastName,
          Role : self.state.Props.Role,
          Tag: self.state.Props.Tag,
          Address : self.state.Props.Address,
          Address2: self.state.Props.Address2,
          City : self.state.Props.City,
          Postal : self.state.Props.Postal,
          AuthorizationToken : self.props.UserReducer.token,
          IsAdmin : self.state.Props.IsAdmin,
          IsStorage : self.state.Props.IsStorage,
          EmailNotif : self.state.Props.EmailNotif.toString(),
          NextOfKin: self.state.Props.NextOfKin,
          PhoneNo: self.state.Props.PhoneNo
        },
        UserReducer: self.props.UserReducer,
        RunRedux : self.props.RunRedux,
        onfailed : onfailed,
        onsuccess : onsuccess,
        permission_needed:permission_needed,
        self:self,
    }
  },
  ResetPasswordProps(onsuccess,onfailed,permission_needed,self){
    return {
        data : {
          Alias : self.state.Props.Alias,
          OldPassword:self.state.Cridential.OldPassword,
          NewPassword:self.state.Cridential.NewPassword,
          AuthorizationToken : self.props.UserReducer.token,
        },
        UserReducer: self.props.UserReducer,
        RunRedux : self.props.RunRedux,
        onfailed : onfailed,
        onsuccess : onsuccess,
        permission_needed:permission_needed,
        self:self,
    }
  },
  Forgot(nick, onsuccess, onfailed) {
    return {
      data: {
        nick : nick
      },
      onsuccess : onsuccess,
      onfailed  : onfailed,
    }
  },
  CheckTokenReset(token, onsuccess, onfailed) {
    return {
      data: {
        token : token
      },
      onsuccess : onsuccess,
      onfailed  : onfailed,
    }
  },
  Reset(password, token, onsuccess, onfailed) {
    return {
      data: {
        token : token,
        password: password,
      },
      onsuccess : onsuccess,
      onfailed  : onfailed,
    }
  },
}



// WEBPACK FOOTER //
// ./src/App/user/model/helper/request.props.js